module.exports = __webpack_public_path__ + "static/media/plan-acumula-200-gigas.5387fb2d.svg";